
import React from "react";
import { Button } from "@/components/ui/button";
import { Wand2 } from "lucide-react";

interface Template {
  id: string;
  title: string;
  merchant: string;
  issue: string;
  amount: string;
}

const templates: Template[] = [
  {
    id: "defective",
    title: "Defective Product",
    merchant: "Amazon",
    issue: "I got my wireless headphones but they're completely broken. The left side doesn't work and the case won't charge at all.",
    amount: "89.99"
  },
  {
    id: "wrong-item",
    title: "Wrong Item",
    merchant: "eBay",
    issue: "I ordered a blue iPhone 14 case but received a red iPhone 13 case that doesn't fit my phone at all.",
    amount: "24.99"
  },
  {
    id: "not-described",
    title: "Not as Described",
    merchant: "Etsy",
    issue: "The necklace was advertised as genuine sterling silver but appears to be silver-plated and turned my skin green after one wear.",
    amount: "45.00"
  }
];

interface QuickTemplatesProps {
  onTemplateSelect: (template: { merchant: string; issue: string; amount: string }) => void;
}

const QuickTemplates = ({ onTemplateSelect }: QuickTemplatesProps) => {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-3">
        <Wand2 className="w-4 h-4 text-primary" />
        <span className="text-sm font-medium text-muted-foreground">Try a sample</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {templates.map((template) => (
          <Button
            key={template.id}
            variant="outline"
            size="sm"
            className="h-auto p-3 text-left hover:bg-accent/50 transition-colors"
            onClick={() => onTemplateSelect({
              merchant: template.merchant,
              issue: template.issue,
              amount: template.amount
            })}
          >
            <span className="font-medium text-xs">{template.title}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickTemplates;
